import React from 'react';
import {RiFacebookFill, RiTwitterFill, RiInstagramFill} from 'react-icons/ri'
import { Link } from 'react-router-dom'
import { CTA } from '../../components'
import './footer.css'

const Footer = () => {
  return (
    <div className='gmc__footer section__padding'>
      <div className='gmc__footer-wrapper'>
        <div className='gmc__footer-company'>
          <h3>Greymate Care</h3>
          <p>Put the days of absenteeism from work due to <br/>caregiving behind you.</p>
          <CTA />
        </div>

        <div className='gmc__footer-links'>
          <h3>Company</h3>
          <ul>
            <li><Link to="/become-caregiver">Become a caregiver</Link></li>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/faqs">FAQs</Link></li>
            <li><Link to="/contact-us">Contact Us</Link></li>
          </ul>
        </div>

        <div className='gmc__footer-links'>
          <h3>More</h3>
          <ul>
            <li><Link to='/home-care-emergencies'>For Home Care Agencies</Link></li>
            <li><Link to='/for-employers'>For Employers</Link></li>
            <li><Link to='/csrs-and-donations'>For CSRs/Donations</Link></li>
          </ul>
        </div>

        <div className='gmc__footer-socials'>
          <h3>Socials</h3>
          <ul>
            <li><a target="_blank" rel="noreferrer" href='https://facebook.com/greymatecare'><RiFacebookFill color="#fff"/></a></li>
            <li><a target="_blank" rel="noreferrer" href='https://twitter.com/greymatecare'><RiTwitterFill color="#fff"/></a></li>
            <li><a target="_blank" rel="noreferrer" href='https://instagram.com/greymatecare'><RiInstagramFill color="#fff"/></a></li>
          </ul>
        </div>
      </div>
      <div className='gmc__footer-copy'>
        <div className='gmc__footer-copy_links'>
          <Link to='/terms-and-conditions'>Terms of Use</Link>
          <Link to='/privacy-policy'>Privacy Policy</Link>
        </div>

        <div className='gmc__footer-copy_text'>
          <p>&copy;Copyright 2022, All Rights Reserved</p>
        </div>
      </div>
    </div>
  )
}

export default Footer